import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { FlatButton } from '../../../../components/button/FlatButton';
import { DialogHeader } from '../../../../components/dialog/DialogHeader';
import { DialogTrigger } from '../../../../components/dialog/DialogTrigger';
import { DateInput } from '../../../../components/form-elements/DateInput';
import { WindloadChecklistReportDocument } from '../../../../models/production/windload-checklist-report-document';

export const WindloadChecklistReport = () => {

    const [isOpen, setIsOpen] = React.useState(false);
    const [startDate, setStartDate] = React.useState(new Date());
    const [endDate, setEndDate] = React.useState(new Date());
    const dispatch = useDispatch();

    /**
     * Handle the dialog open click
     */
    const onOpenClick = () => {
        setIsOpen(true);
    };

    /**
     * Handle the diaog close click
     */
    const onCloseClick = () => {
        setStartDate(new Date());
        setEndDate(new Date());
        setIsOpen(false);
    };

    /**
     * Handler for changing the start date.
     * @param newDate The new start date as chosen 
     */
    const onStartDateChange = (newDate: Date) => {
        setStartDate(newDate);
    };

    /**
     * Handler for changing the end date.
     * @param newDate The new end date as chosen 
     */
    const onEndDateChange = (newDate: Date) => {
        setEndDate(newDate);
    };

    /**
     * Format the dates and initiate the AccountMate report command
     */
    const runReport = () => {
        if (startDate && endDate) {
            const req = new WindloadChecklistReportDocument(startDate, endDate);
            dispatch(getDocumentHelper(req));
            onCloseClick();
        }
    };

    return (
        <React.Fragment>
            <div className="report-card-wrap blue">
                <div className="row">
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <h3>Windload Checklist Report</h3>
                                <p>Get a list of reports where a windload signature is required.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <DialogTrigger
                                    onClick={onOpenClick}
                                    text="Run Report" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={isOpen}
                className="report-dialog"
                onClose={onCloseClick}
                maxWidth="md"
                aria-labelledby="form-dialog-title">

                <DialogHeader>
                    <h1>Windload Checklist report</h1>
                </DialogHeader>

                <DialogContent>
                    <div className="row">
                        <div className="col">
                            <p>Provide a start date and an end date to search</p>
                        </div>
                    </div>
                    <div className="row justify-content-around">
                        <div className="col-auto">
                            <DateInput
                                id="endDate"
                                label="Start Date"
                                value={startDate}
                                onChange={onStartDateChange}
                                inline={true}
                            />
                        </div>
                        <div className="col-auto">
                            <DateInput
                                id="endDate"
                                label="End Date"
                                value={endDate}
                                onChange={onEndDateChange}
                                inline={true}
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <FlatButton
                        id="windloadReportNoBtn"
                        text="Cancel"
                        classes="negative"
                        onBtnClick={onCloseClick} />
                    <FlatButton
                        id="windloadReportYesBtn"
                        text="Go"
                        classes="positive"
                        onBtnClick={runReport} />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );

};
